import { supabase } from '../supabase/client';
import { LoginFormData } from '@/types/auth';
import { AUTH_ERRORS } from '@/lib/constants/auth';

export const signInWithEmail = async ({ email, password, rememberMe }: LoginFormData) => {
  try {
    const { data: authData, error: authError } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (authError) throw authError;
    if (!authData.user) throw new Error(AUTH_ERRORS.NO_USER_DATA);

    const { data: userData, error: profileError } = await supabase
      .from('users')
      .select('*')
      .eq('id', authData.user.id)
      .single();

    if (profileError) {
      await supabase.auth.signOut();
      throw new Error(AUTH_ERRORS.PROFILE_FETCH_ERROR);
    }

    return { user: userData, session: authData.session };
  } catch (error) {
    console.error('Sign in error:', error);
    throw error;
  }
};

export const signOut = async () => {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
};

export const getCurrentSession = async () => {
  const { data: { session }, error } = await supabase.auth.getSession();
  if (error) throw error;
  return session;
};

export const initializeAuth = async () => {
  try {
    const { data: { session }, error } = await supabase.auth.getSession();
    if (error) throw error;
    
    if (!session) {
      return null;
    }

    const { data: userData, error: profileError } = await supabase
      .from('users')
      .select('*')
      .eq('id', session.user.id)
      .single();

    if (profileError) throw profileError;
    return userData;
  } catch (error) {
    console.error('Error initializing auth:', error);
    return null;
  }
};